import React, { ChangeEvent } from 'react';

import FormFieldLabel from './FormFieldLabel';
import { IFormFieldProps } from './models';
import { useFormField } from './useFormField';

type Props = Omit<IFormFieldProps, 'optional'> & Required<Pick<IFormFieldProps, 'label'>>;

function FormToggleField({ name, label, size }: Props) {
  const { id, fieldProps, setValue, meta } = useFormField<boolean>(name, size);

  const onChange = async (event: ChangeEvent<HTMLInputElement>) => {
    await setValue(event.target.checked);
  };

  return (
    <div className={`${fieldProps.className} modFormField--toggle`}>
      <label className="modFormFieldToggle">
        <input
          id={id}
          className="modFormFieldToggle__input"
          type="checkbox"
          onChange={onChange}
          checked={meta.value}
          style={{ display: 'none' }}
        />
        <span className="modFormFieldToggle__switch" />
      </label>

      {label && <FormFieldLabel htmlFor={id}>{label}</FormFieldLabel>}
    </div>
  );
}

export default FormToggleField;
